import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.Languages.Title',
        defaultMessage: `{count, plural,
            =0 {languages spoken}
            other {languages spoken (#)}
        }`,
    },
    NoPreference: {
        id: 'Components.RefineSearch.Languages.NoPreference',
        defaultMessage: 'no preference',
    },
    Spanish: {
        id: 'Components.RefineSearch.Languages.Spanish',
        defaultMessage: 'spanish',
    },
    SeeMore: {
        id: 'Components.RefineSearch.Languages.SeeMore',
        defaultMessage: 'see more languages',
    },
});

export const SPANISH = '3';
export const DEFAULT = '-1';
